var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c("div", { staticClass: "page-container" }, [
            _c(
              "div",
              { staticClass: "tabs" },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: { value: _vm.activiedTab, type: "card" },
                    on: { "tab-click": _vm.handleTabClick },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { name: "1", label: "线上数据" },
                    }),
                    _c("el-tab-pane", {
                      attrs: { name: "0", label: "本地数据" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticClass: "table table-wrap",
                attrs: { "element-loading-text": "加载中" },
              },
              [
                _vm.isLocal
                  ? _c(
                      "div",
                      { staticClass: "local-table" },
                      [
                        _c(
                          "avue-crud",
                          {
                            ref: "crud",
                            attrs: {
                              option: _vm.avueOption,
                              "table-loading": _vm.loading,
                              data: _vm.tableData,
                              page: _vm.page,
                            },
                            on: {
                              "selection-change": _vm.handleSelect,
                              "current-change": _vm.currentChange,
                              "refresh-change": _vm.refreshChange,
                              "on-load": _vm.onLoad,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "menu",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "ACTIVITY_VIEW_LOG",
                                              expression: "'ACTIVITY_VIEW_LOG'",
                                            },
                                          ],
                                          attrs: { size: "mini", type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleCheckLogs(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("查看日志")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "ACTIVITY_EDIT",
                                              expression: "'ACTIVITY_EDIT'",
                                            },
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.row.reviewStatus != 1,
                                              expression:
                                                "scope.row.reviewStatus != 1",
                                            },
                                          ],
                                          attrs: { size: "mini", type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEdit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "ACTIVITY_APPROVE",
                                              expression: "'ACTIVITY_APPROVE'",
                                            },
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.row.reviewStatus == 1,
                                              expression:
                                                "scope.row.reviewStatus == 1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "text",
                                            loading: _vm.approveLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleApprove(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("审核")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "ACTIVITY_REVOCATION",
                                              expression:
                                                "'ACTIVITY_REVOCATION'",
                                            },
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.row.reviewStatus == 1,
                                              expression:
                                                "scope.row.reviewStatus == 1",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "text",
                                            loading: _vm.approveLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRevocation(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("撤销审核")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "ACTIVITY_APPROVE_SUBMIT",
                                              expression:
                                                "'ACTIVITY_APPROVE_SUBMIT'",
                                            },
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                scope.row.reviewStatus == 0,
                                              expression:
                                                "scope.row.reviewStatus == 0",
                                            },
                                          ],
                                          attrs: {
                                            size: "mini",
                                            type: "text",
                                            loading: _vm.approveLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleApproveRequest(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("提交审核")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              53315117
                            ),
                          },
                          [
                            _c("template", { slot: "menuLeft" }, [
                              _c(
                                "div",
                                { staticClass: "query-form-wrap" },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      attrs: {
                                        inline: true,
                                        model: _vm.form,
                                        size: _vm.formSize,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder:
                                                  "请选择企业会员商品",
                                              },
                                              on: {
                                                focus: _vm.handleSearchChannel,
                                              },
                                              model: {
                                                value:
                                                  _vm.form.distributeProductId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "distributeProductId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.distributeProductId",
                                              },
                                            },
                                            _vm._l(
                                              _vm.productLists,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "状态",
                                              },
                                              model: {
                                                value: _vm.form.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.status",
                                              },
                                            },
                                            _vm._l(
                                              _vm.partnerStatusOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.dictKey,
                                                  attrs: {
                                                    label: item.dictValue,
                                                    value: item.dictKey,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isLocal,
                                              expression: "isLocal",
                                            },
                                          ],
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "审核状态",
                                              },
                                              model: {
                                                value: _vm.form.reviewStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "reviewStatus",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.reviewStatus",
                                              },
                                            },
                                            _vm._l(
                                              _vm.approveStatusOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.dictKey,
                                                  attrs: {
                                                    label: item.dictValue,
                                                    value: item.dictKey,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "auth",
                                                  rawName: "v-auth",
                                                  value: "ACTIVITY_SEARCH",
                                                  expression:
                                                    "'ACTIVITY_SEARCH'",
                                                },
                                              ],
                                              attrs: {
                                                loading: _vm.listLoading,
                                                icon: "el-icon-search",
                                                type: "primary",
                                              },
                                              on: { click: _vm.handleSearch },
                                            },
                                            [_vm._v("搜索")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "auth",
                                                  rawName: "v-auth",
                                                  value: "ACTIVITY_ADD",
                                                  expression: "'ACTIVITY_ADD'",
                                                },
                                              ],
                                              attrs: {
                                                icon: "el-icon-plus",
                                                plain: "",
                                                type: "primary",
                                              },
                                              on: { click: _vm.handleOpen },
                                            },
                                            [_vm._v("新增")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "auth",
                                                  rawName: "v-auth",
                                                  value: "ACTIVITY_DELETE",
                                                  expression:
                                                    "'ACTIVITY_DELETE'",
                                                },
                                              ],
                                              attrs: {
                                                icon: "el-icon-delete",
                                                loading: _vm.delLoading,
                                                plain: "",
                                                type: "danger",
                                              },
                                              on: { click: _vm.handleDelete },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "online-table" },
                      [
                        _c(
                          "avue-crud",
                          {
                            ref: "crud2",
                            attrs: {
                              option: _vm.onLineOption,
                              "table-loading": _vm.loading,
                              data: _vm.tableData,
                              page: _vm.page,
                            },
                            on: {
                              "current-change": _vm.currentChange,
                              "on-load": _vm.getList,
                            },
                          },
                          [
                            _c("template", { slot: "menuLeft" }, [
                              _c(
                                "div",
                                { staticClass: "query-form-wrap" },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      attrs: {
                                        inline: true,
                                        model: _vm.form,
                                        size: _vm.formSize,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder:
                                                  "请选择企业会员商品",
                                              },
                                              model: {
                                                value:
                                                  _vm.form.distributeProductId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "distributeProductId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.distributeProductId",
                                              },
                                            },
                                            _vm._l(
                                              _vm.productLists,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "状态",
                                              },
                                              model: {
                                                value: _vm.form.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.status",
                                              },
                                            },
                                            _vm._l(
                                              _vm.partnerStatusOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.dictKey,
                                                  attrs: {
                                                    label: item.dictValue,
                                                    value: item.dictKey,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "auth",
                                                  rawName: "v-auth",
                                                  value: "ACTIVITY_SEARCH",
                                                  expression:
                                                    "'ACTIVITY_SEARCH'",
                                                },
                                              ],
                                              attrs: {
                                                loading: _vm.listLoading,
                                                icon: "el-icon-search",
                                                type: "primary",
                                              },
                                              on: { click: _vm.handleSearch },
                                            },
                                            [_vm._v("搜索")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
              ]
            ),
          ]),
          _c("add-sales-scheme-popups", {
            attrs: {
              row: _vm.currentRow,
              visible: _vm.showAdd,
              "is-edit": _vm.isEdit,
              products: _vm.productLists,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showAdd = $event
              },
              "update:isEdit": function ($event) {
                _vm.isEdit = $event
              },
              "update:is-edit": function ($event) {
                _vm.isEdit = $event
              },
              onSubmit: _vm.handleSubmit,
            },
          }),
          _c("approve-popups", {
            attrs: {
              loading: _vm.approveLoading,
              visible: _vm.showApprove,
              data: _vm.currentRow,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showApprove = $event
              },
              approve: _vm.submitApprove,
            },
          }),
          _c("approve-log-popups", {
            attrs: { logs: _vm.logs, visible: _vm.showLog },
            on: {
              "update:visible": function ($event) {
                _vm.showLog = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }